import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ClipboardListIcon, CalendarIcon } from 'lucide-react';
import { CTARow } from './CTARow';
export function HowItWorksSection() {
  const steps = [{
    icon: PhoneIcon,
    title: 'Caller Dials',
    description: 'Caller dials your business number – Jessica answers instantly, every time.'
  }, {
    icon: ClipboardListIcon,
    title: 'Jessica Qualifies',
    description: 'She answers questions, collects details, and qualifies the caller for you.'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Booked',
    description: 'Qualified leads are booked directly into your calendar and summarized for you.'
  }];
  return <section className="py-20 bg-white" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-91">
            How Your AI Receptionist Works.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-92">
            Simple, seamless, and effective.
          </motion.p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-93">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-200 -z-10" data-id="element-94" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center bg-white" data-id="element-95">
              <div className="w-24 h-24 bg-white border-4 border-viridia-50 rounded-full flex items-center justify-center mb-6 shadow-sm relative z-10" data-id="element-96">
                <div className="w-20 h-20 bg-viridia-500 rounded-full flex items-center justify-center text-white" data-id="element-97">
                  <step.icon className="w-10 h-10" data-id="element-98" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center font-bold border-2 border-white" data-id="element-99">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-100">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed max-w-xs" data-id="element-101">
                {step.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-viridia-50 rounded-2xl p-8 max-w-4xl mx-auto" data-id="element-102">
          <p className="text-xl font-medium text-viridia-800 mb-8" data-id="element-103">
            No more voicemail tag. No more wondering how many jobs you lost
            overnight.
          </p>
          <CTARow align="center" data-id="element-104" />
        </motion.div>
      </div>
    </section>;
}